import React from 'react';
import { TableWithHeader } from 'dyl-components';
import { Grid } from 'semantic-ui-react';

import RingOptionsForm from './RingOptionsForm';
import RingOptionsHeader from './RingOptionsHeader';

export default class RingOptions extends React.Component {
    state = {
        isEditMode: false,
        info: this.props.info
    }

    onEnableEditMode = () => {
        this.setState({
            isEditMode: true
        })
    }

    onCloseEditMode = () => {
        this.setState({
            isEditMode: false,
            info: this.props.info
        })
    }

    onUpdate = () => {
        this.setState({
            isEditMode: false,
        }, () => {
            this.props.onUpdate({
                ...this.state.info
            })
        });
    }

    onChange = (_, {name, value}) => {
        let info = {...this.state.info, [name]: value};
        this.setState({
            info
        });
    }

    render() {
        return (
            <TableWithHeader 
                header={(
                    <RingOptionsHeader 
                        isEditMode={this.state.isEditMode}
                        onCloseEditMode={this.onCloseEditMode}
                        onEnableEditMode={this.onEnableEditMode}
                        onUpdate={this.onUpdate}
                    />
                )}
                table={(
                    <Grid celled style={{margin: 0}} verticalAlign='middle'>
                        <RingOptionsForm
                            info={this.state.info}
                            isEditMode={this.state.isEditMode}
                            onChange={this.onChange}
                        />
                    </Grid>
                )}
            />
        )
    }
}
